<template>
    <div>
        <el-row>
            <el-col :span="24">
                <Head>
                    <template v-slot:title>
                        <span style="margin-left:30%;">聊天</span>
                    </template>
                </Head>
            </el-col>
        </el-row>
        <el-row class="row-top" type="flex" justify="center">
            <el-col :span="15" style="background-color:white;">
            
                <el-row style="height:100%;">
                    <!-- 左侧 -->
                    <el-col :span="8" style="height:100%;">
                        <charList @getUserInofFn="getUserInfo"></charList>
                    </el-col>

                    <!-- 右侧 -->
                    <el-col :span="16">
                        
                        <el-row class="btn-box">
                            <el-col class="chat_btn">
                                <span class="active">聊天</span>
                            </el-col>
                        </el-row>
                    
                    <!-- 内容部分 -->
                        <el-row>
                            <chatLt @getStatusFun="getStatus" :conversationVosArr="conversationVosArr"></chatLt>
                        </el-row>
                    </el-col>
                </el-row>
               
            </el-col>
        </el-row>
    
    </div>
</template>
<script>
import Head from '@/components/header/head.vue';
import charList from '@/components/chat/chat_list.vue';
import chatLt from '@/views/chat/chat_lt.vue';
;


export default {
    data(){
        return {
           
            userInfo:'',    // 存放用户信息
            identityStatus:'1',  // 身份状态
            
            conversationVosArr:[],  // 用户信息详情
        }
    },
    methods:{
        // 获得聊天列表消息
        getMeaageList(){
            this.axiosGet(`/conversation/selectByUserId?userId=${this.userInfo.id}&identityStatus=${this.identityStatus}`).then((res)=>{
                console.log('消息list')
                console.log(res)
                if(res.code==200){
                    this.$store.commit('updateMsg',res.data)
                    //   publicVue.chartInfo = res.data
                    console.log('消息list')
                    console.log(res.data)
                    //   this.$store.commit('updateMsgNum',res.dataunreadNewsCount)
                }
            })
        },

    // 显示发送简历弹框函数/显示工作简历弹框函数
       getStatus(isShow,status){
        // console.log(isShow,status)
           this.dialogVisible = isShow || false
           this.showResume = status || false
       },

    // 获取用户列表信息
        getUserInfo(userInfo,status){
            if(userInfo!=null){
                this.conversationVosArr = userInfo.data
            }
            //    console.log('conversationVosArr')
            //    console.log(this.conversationVosArr)
        }
    },
    components:{
        Head,
        charList,
        chatLt,
    },
    created(){
        this.userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
        this.getMeaageList()
    }
}
</script>
<style lang="less" scoped>
        .chat_btn{
            span{
                display:inline-block;
                text-align:center;
                width: 100px;
                height: 46px;
                border-radius: 8px;         
                background: #EEF2FB; 
                font-size: 18px;
                font-weight: 400;
                color: #868EA7;
                line-height: 46px;
                cursor:pointer;
            }
            span:first-of-type{
                margin-left:10%;
            }
            span:last-of-type{
                margin-left:5%;
            }
            span.active{           
                background: #1A80FC;
                color:#ffffff;
            }
        }


        .row-top{
            height:55%;
            .head{
                height:58px;
                background: #F9FAFB;               
                box-shadow: 0px 0px 13px 3px rgba(141, 141, 141, 0.11);
            }
        }

        .btn-box{
            height:58px;
            background: #F9FAFB;
            box-shadow: 0px 0px 13px 3px rgba(141, 141, 141, 0.11);
            line-height:58px;
        }




    // 发送面试邀请弹框
        .title{
            text-align:center;    
            font-size: 18px;
            font-weight: 400;
            color: #333333;
            line-height: 30px;
        }
        .cancel,
        .send{
            width:100px;
            height:46px;
        }
        .send{      
            font-size: 16px;
            font-weight: 400;
            color: #FFFFFF;
            margin-left:15%;
        }
        .cancel{
            font-size: 18px;
            font-weight: 400;
            color: #868EA7;
        }
        .inp{
            width:88%;
        }
</style>